import type { Workspace } from '@/lib/queries/workspaces'

type WorkspaceAccessInput = {
  workspace: Pick<Workspace, 'created_by' | 'visibility'>
  profileId: string
  isOrgAdmin: boolean
}

function isOwnerOrOrgAdmin({
  workspace,
  profileId,
  isOrgAdmin,
}: WorkspaceAccessInput): boolean {
  return isOrgAdmin || workspace.created_by === profileId
}

/** Only members of a private workspace gain rights from membership. */
export function needsWorkspaceMembership(input: WorkspaceAccessInput): boolean {
  return input.workspace.visibility === 'private' && !isOwnerOrOrgAdmin(input)
}

/**
 * Owners and org admins have full control; members of a private workspace can
 * manage it but not delete it.
 */
export function getWorkspaceAccess(
  input: WorkspaceAccessInput & { isWorkspaceMember: boolean }
) {
  const ownerOrAdmin = isOwnerOrOrgAdmin(input)
  return {
    canManage:
      ownerOrAdmin ||
      (needsWorkspaceMembership(input) && input.isWorkspaceMember),
    canDelete: ownerOrAdmin,
  }
}
